import React from 'react';
import { connect } from 'react-redux';
import TWAvatarDropdown from '../TWAvatarDropdown/TWAvatarDropdown.profile.container';
import { TWTopNav } from '.';
import { showNavbar as showNavbarAction } from '../../state/actions';
import TWLogo from '../TWLogo/TWLogo.provider';
import { jsx as _jsx } from "react/jsx-runtime";

var TWTopNavProvContainer = function TWTopNavProvContainer(_ref) {
  var showNavbar = _ref.showNavbar;
  return /*#__PURE__*/_jsx(TWTopNav, {
    onClose: showNavbar,
    leftSlot: /*#__PURE__*/_jsx(TWLogo, {}),
    rightSlot: /*#__PURE__*/_jsx(TWAvatarDropdown, {}),
    navLinks: [{
      text: 'Support',
      href: '#',
      hidden: true
    }, {
      text: 'Blog',
      href: '#',
      hidden: true
    }]
  });
};

var mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showNavbar: function showNavbar() {
      return dispatch(showNavbarAction());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TWTopNavProvContainer);